import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getListingExistsInListingHub } from '../api-ts';

export function useGetListingExistsWithRetry(listingAlias: string) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getListingExistsInListingHub', listingAlias],
    queryFn: async () => {
      const response = await dispatch(getListingExistsInListingHub(listingAlias));
      if (!response.data.response) {
        throw { error: 'listing not yet in listing hub' };
      }
      return response.data.response;
    },
    enabled: !!listingAlias,
    retry: 100,
    retryDelay: 2000,
  });
}
